<div class="form-container">
  <div class="header-form">
    <fa-icon [icon]="getFaIcon('faChevronLeft')" class="backIcon" (click)="back()" (keypress)="back()" matTooltip="Annuler"
      appChangeColorTheme attribute="color">
    </fa-icon>

    <div class="title">{{ !formDefinition ? "Création d'un nouveau formulaire" : "Édition du formulaire"}}</div>
    <button class="back" (click)="back()">Annuler</button>

  </div>

  <div class="form" [formGroup]="form">
    <div class="mandatory-fields">
      <div class="created-on" *ngIf="formDefinition">
        <strong>Créé le : </strong> <span>{{ formDefinition?.createdOn | date:'dd/MM/yyyy' }}</span>
      </div>

      <mat-form-field appearance="outline">
        <mat-label>Nom</mat-label>
        <input id="" matInput formControlName="name" required />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Description</mat-label>
        <textarea id="" matInput formControlName="description"></textarea>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Acteurs</mat-label>
        <mat-select formControlName="club" (selectionChange)="onSelectClub($event)" multiple>
          <mat-option *ngFor="let club of clubs" [value]="club">
            <strong>{{ club.clubCode }}</strong> - <span>{{ club.clubName }}</span>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="personalized-fields">
      <app-field-group [fields]="fields" view="edit" (fieldsChange)="onFieldsChange($event)"></app-field-group>
    </div>
  </div>

  <div class="actions">
    <ng-container *ngIf="!isLoading; else loadingTemplate">
      <button mat-raised-button class="cancel" (click)="cancel()">Annuler</button>
      <button mat-raised-button [disabled]="form.invalid || !canCustomFieldsSubmit" class="save" (click)="save()">
        <span>{{ !formDefinition ? "Ajouter" : "Sauvegarder"}}</span>
      </button>
    </ng-container>

    <ng-template #loadingTemplate>
      <mat-spinner diameter="50"></mat-spinner>
    </ng-template>
  </div>
</div>
